import { render, staticRenderFns } from "./NBtnContent.vue?vue&type=template&id=cea72f72"
import script from "./NBtnContent.vue?vue&type=script&lang=js"
export * from "./NBtnContent.vue?vue&type=script&lang=js"
import style0 from "./NBtnContent.vue?vue&type=style&index=0&id=cea72f72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports